// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"885":"6527308b","966":"6527308b"}[chunkId] + ".chunk.css";
};